<template>
  <v-autocomplete
    v-model="val"
    :items="options"
    :outlined="outlined"
    :readonly="readonly"
    :dense="dense"
    :label="renderLabel"
    :class="renderClasses"
    ref="autocomplete"
    @change="onChange" />
</template>

<script>
import InputMixin from './mixins/InputMixin'

export default {
  name: '',

  mixins: [
    InputMixin
  ],

  computed: {
    options () {
      const from = 1950
      const to = 2020

      return Array.from(Array(to - from).keys()).map(n => (to - n).toString())
    }
  },

  methods: {
    onChange () {
      this.$refs && this.$refs.autocomplete
        ? this.$refs.autocomplete.blur()
        : void 0
    },

    isValueTypeValid (value) {
      return typeof value === 'number' || typeof value === 'string'
    }
  }
}
</script>
